// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const cargoBarge = defineModel({
  id: "cargo-barge",
  batchId: "future",
  name: "Cargo barge",
  tags: ["scenery","cargo","barge","low-poly","age-of-mcp","future","water"],
  summary: "A flat cargo barge — moves bulk goods cheaply along rivers and canals.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.9,
  parts: () => [
      { geometry: new THREE.BoxGeometry(1.4, 0.22, 0.6), color: "#5f6b72", position: [0, 0.13, 0] },
      { geometry: new THREE.BoxGeometry(1.22, 0.1, 0.46), color: "#454e54", position: [0, -0.01, 0] },
      { geometry: new THREE.BoxGeometry(1.4, 0.06, 0.04), color: "#454e54", position: [0, 0.26, 0.28] },
      { geometry: new THREE.BoxGeometry(1.4, 0.06, 0.04), color: "#454e54", position: [0, 0.26, -0.28] },
      { geometry: new THREE.BoxGeometry(1.2, 0.03, 0.48), color: "#7a6a4e", position: [0, 0.24, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.22, 0.22), color: "#a9763f", position: [0.18, 0.36, 0.1] },
      { geometry: new THREE.BoxGeometry(0.2, 0.2, 0.2), color: "#8f6234", position: [0.18, 0.58, 0.1] },
      { geometry: new THREE.BoxGeometry(0.22, 0.22, 0.22), color: "#8f6234", position: [0.18, 0.36, -0.12] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.24, 8), color: "#6d4a2a", position: [0.46, 0.37, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.24, 8), color: "#6d4a2a", position: [0.46, 0.37, -0.12] },
      { geometry: new THREE.BoxGeometry(0.3, 0.26, 0.4), color: "#8a8478", position: [-0.52, 0.38, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.06, 0.44), color: "#4a5258", position: [-0.52, 0.53, 0] },
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 0.18, 5), color: "#454e54", position: [-0.66, 0.35, 0], rotation: [0, 0, 0.4] },
    ],
  animations: [],
});
